import React from 'react'
import ComingSoon from '../components/ComingSoon'

const TopSellItineraries = () => {
  return (
    <>
        <ComingSoon />
    </>
  )
}

export default TopSellItineraries